<template>
  <div class="no-results">
    <SearchQuestionIcon />
    <div class="no-results__description">Мы не смогли ничего найти<br />по этому запросу</div>
  </div>
</template>

<script>
import SearchQuestionIcon from '@/components/Icons/SearchQuestionIcon';

export default {
  name: 'NoResults',
  components: {
    SearchQuestionIcon
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../style/utils/index';

.no-results {
  margin-top: 20vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &__description {
    text-align: center;
    color: $ui-light-grey-4-5-contrast;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
